import React from 'react';
import { useTheme } from '../../styles/ThemeProvider';
import { SkeletonChart, EmptyState, ErrorState } from './states';

export const ChartCard = ({
  title,
  subtitle,
  actions,
  children,
  loading,
  error,
  empty,
  onRetry,
  footer,
  height = 260,
  autoHeight = false, // true → içerik kadar (tablo/KPI grid gibi auto-grow içerikler için)
}) => {
  const { theme } = useTheme();

  const body = (() => {
    if (loading) return <SkeletonChart height={height} />;
    if (error) return <ErrorState message={error} onRetry={onRetry} />;
    if (empty) return <EmptyState />;
    return <div style={autoHeight ? undefined : { height }}>{children}</div>;
  })();

  return (
    <div style={{
      background: theme.color.surface,
      border: `1px solid ${theme.color.border}`,
      borderRadius: theme.radius.md,
      padding: theme.space.lg,
      boxShadow: theme.shadow.sm,
      display: 'flex',
      flexDirection: 'column',
      gap: theme.space.md,
      fontFamily: theme.font.family,
    }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: theme.space.md }}>
        <div>
          <div style={{
            fontSize: theme.font.size.base,
            fontWeight: theme.font.weight.semibold,
            color: theme.color.text,
          }}>{title}</div>
          {subtitle && (
            <div style={{ fontSize: theme.font.size.xs, color: theme.color.textSoft, marginTop: 2 }}>{subtitle}</div>
          )}
        </div>
        {actions && <div>{actions}</div>}
      </div>
      {body}
      {footer && (
        <div style={{ fontSize: theme.font.size.xs, color: theme.color.muted, borderTop: `1px solid ${theme.color.border}`, paddingTop: theme.space.md }}>
          {footer}
        </div>
      )}
    </div>
  );
};
